import { render, staticRenderFns } from "./OrganizationMdtListDisease.vue?vue&type=template&id=07648b26&scoped=true"
import script from "./OrganizationMdtListDisease.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtListDisease.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtListDisease.vue?vue&type=style&index=0&id=07648b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07648b26",
  null
  
)

export default component.exports